import React from 'react'
import T from 'prop-types'
import { styled } from '@mui/material/styles'
import { Box, Stack, Typography } from '@mui/material'
import DiamondOutlinedIcon from '@mui/icons-material/DiamondOutlined'
import { getFormattedAmount } from 'lib/carDetailsLib'

import SixtIcon from 'components/atoms/SixtIcon'

import CarDetailsItem from './CarDetailsItem'

const classes = {
  carDetailsItem: 'car-details-item',
  carDetailsItemTitle: 'car-details-item-title',
  carDetailsItemIcon: 'car-details-item-icon',
  carDetailsItemValue: 'car-details-item-value',
}
const Root = styled('div')(({ theme }) => ({
  [`&.${classes.carDetailsItem}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    [`& .${classes.carDetailsItemIcon}`]: {
      marginRight: theme.spacing(1),
    },
    [`& .${classes.carDetailsItemTitle}`]: {
      display: 'flex',
      alignItems: 'center',
    },
  },
}))

export default function CarDetailsRightColumn({
  car,
  price,
  fee,
  bottom,
  hideTotalPrice,
  isAssignement,
}) {
  const numberFormatter = new Intl.NumberFormat('it-IT')
  const priceNetToShow = price
  const feeToShow = fee

  return (
    <Root data-testId="car-details-right-column">
      <Typography
        variant="body1"
        color="textPrimary"
        className={classes.carTitle}
        sx={{ mb: 0.5 }}
      >
        <strong data-testId="car-details-right-column-brand">
          {car.brand} {car.model}
        </strong>
      </Typography>
      <Typography
        variant="body2"
        color="textSecondary"
        className={classes.carSubtitle}
        sx={{ mb: 1 }}
      >
        {car.title}
      </Typography>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Stack>
          {!hideTotalPrice && (
            <Typography
              variant="body1"
              color="primary"
              className={classes.carPrice}
            >
              {isAssignement ? (
                <strong>
                  €{' '}
                  {priceNetToShow
                    ? numberFormatter.format(priceNetToShow + feeToShow)
                    : '-'}
                </strong>
              ) : (
                <strong>
                  € {numberFormatter.format(priceNetToShow + feeToShow)}
                </strong>
              )}
            </Typography>
          )}
          <Stack direction="row">
            <CarDetailsItem
              icon={<SixtIcon />}
              value={
                isAssignement && !priceNetToShow
                  ? '-'
                  : getFormattedAmount(priceNetToShow)
              }
              valueProps={{ variant: 'caption' }}
            />
            <Box pr={2} />
            <CarDetailsItem
              icon={DiamondOutlinedIcon}
              value={
                isAssignement && !priceNetToShow
                  ? '-'
                  : getFormattedAmount(feeToShow)
              }
              valueProps={{ variant: 'caption' }}
            />
          </Stack>
        </Stack>
      </Stack>
      {bottom}
    </Root>
  )
}

CarDetailsRightColumn.propTypes = {
  car: T.object.isRequired,
  price: T.number,
  fee: T.number,
  priceLabel: T.string,
  hideTotalPrice: T.bool,
  isAssignement: T.bool,
  bottom: T.node,
}
